export default "__VITE_ASSET__Cu09Tiv0__"